var map = {
	"./carrefour.svg": 637,
	"./coto.svg": 3108,
	"./dafiti.svg": 3565,
	"./easy.svg": 3000,
	"./fravega.svg": 1951,
	"./jumbo.svg": 2310,
	"./manual.svg": 5065
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4636;